import * as React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { goToGuideNextStep } from 'helpers/trackerHelpers';
import { useAlertForm } from '../Contexts/AlertFormContext';

type Props = {
    disabled?: boolean;
    onNextStep?: () => void;
    className?: string;
};

const NextStepButton = ({ disabled = false, onNextStep, className }: Props) => {
    const { setActiveStep } = useAlertForm();
    const { t } = useTranslation();
    const nextStep = () => {
        if (onNextStep) {
            onNextStep();
        }
        goToGuideNextStep();
        setActiveStep((prevState) => prevState + 1);
    };

    return (
        <Button
            endIcon={<ChevronRightIcon />}
            disabled={disabled}
            onClick={nextStep}
            sx={{ mt: 2 }}
            className={className}
        >
            {t('alert.create.next')}
        </Button>
    );
};

export default NextStepButton;
